module.exports = __webpack_public_path__ + "img/maps.1f7c7808.png";